/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
	AccessTokenResource,
	BenefitsAndPrivacyResource,
	CarGiftResource,
	CarInfoResource,
	CarResource,
	CheckRegisterResource,
	DiscountResource,
	EmailResource,
	EventRegistrationIndexResource,
	EventRegistrationShowResource,
	EventResource,
	EventShowResource,
	GrModalResource,
	GroupAppsResource,
	HomeResource,
	HomeResourceV2,
	LocationResource,
	NotificationResource,
	OrderActivityStatusResource,
	OrderListResource,
	OrderShowResource,
	OrderStoreAuthResource,
	OrderStoreResource,
	OtpValidationResource,
	PaymentResultResource,
	PrivacyResource,
	ReservationInstantAvailableRsvDateTimeResource,
	ReservationInstantReserveResource,
	ReservationItemResource,
	ReservationListResource,
	ReservationShowResource,
	SalesResource,
	ScoreStoreRequest,
	SurveycakeReferralResource,
	UserShowResource,
	V1AppAiSalesListRequestParams,
	V1AppAuthBenefitsAndPrivacyVersionCreateRequestPayload,
	V1AppAuthCheckRegisterCreateRequestPayload,
	V1AppAuthConfirmPasswordCreateRequestPayload,
	V1AppAuthEmailListRequestParams,
	V1AppAuthLoginCreateRequestPayload,
	V1AppAuthOtpValidationCreateRequestPayload,
	V1AppAuthRegisterCreateRequestPayload,
	V1AppAuthRegisterProfileCreateRequestPayload,
	V1AppAuthResetPasswordCreateRequestPayload,
	V1AppAuthSendSmsOtpCreateRequestPayload,
	V1AppAuthSmsOtpValidationCreateRequestPayload,
	V1AppAuthUpdatePasswordCreateRequestPayload,
	V1AppBonusOrderActivityCreatePendingBonusOrderCreateRequestPayload,
	V1AppBonusOrderActivityOrderActivityStatusListRequestParams,
	V1AppCarsDetailRequestParams,
	V1AppCarsGiftsListRequestParams,
	V1AppCarsListRequestParams,
	V1AppCityRegionsListRequestParams,
	V1AppDevicesPseudoIdUpdateRequestPayload,
	V1AppDevicesRegisterCreateRequestPayload,
	V1AppDevicesRegisterIdUpdateRequestPayload,
	V1AppGiftsStatusListRequestParams,
	V1AppGroupAppsListRequestParams,
	V1AppInstantReservationsAvailableRsvDateTimeListRequestParams,
	V1AppInstantReservationsCreateRequestPayload,
	V1AppLbsMessagesNotificationCreateRequestPayload,
	V1AppLocationsListRequestParams,
	V1AppMobileCreateRequestPayload,
	V1AppMobileVerifyCreateRequestPayload,
	V1AppNotificationsAnalyticCreateRequestPayload,
	V1AppOrdersCreateRequestPayload,
	V1AppReservationItemsListRequestParams,
	V1AppReservationsCreateRequestPayload,
	V1AppSalesListRequestParams,
	V1AppSurveycakeReferralCreateRequestPayload,
	V1AppUserAccountUpdateRequestPayload,
	V1AppUserUpdateRequestPayload,
	V1WebBranchCarsCreateRequestPayload,
	V1WebBranchChargingsCreateRequestPayload,
	V1WebBranchSalesCreateRequestPayload,
	V1WebCarPowersCreateRequestPayload,
	V1WebEcpayPaymentCreateRequestPayload,
	V1WebOrderPaymentsCreateRequestPayload,
	V1WebOrdersUpdateRequestPayload,
	V2WebAuthLoginCreateRequestPayload,
	V2AppAuthLoginCreateRequestPayload,
	V2AppDevicesRegisterCreateRequestPayload,
	V2AppOrdersCreateRequestPayload,
	V2AppReservationsCreateRequestPayload,
	V3AppDevicesRegisterCreateRequestPayload,
	V3AppOrdersCreateRequestPayload,
	V3AppReservationsCreateRequestPayload,
	V4AppOrdersCreateRequestPayload,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Api<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description 檢查用戶資格
	 *
	 * @tags Ai
	 * @name V1AppAiCheckUserList
	 * @summary 檢查用戶資格
	 * @request GET:/api/v1/app/ai/checkUser
	 * @secure
	 */
	v1AppAiCheckUserList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 是否為Cr會員
					 * @example "false"
					 */
					is_cr_member?: boolean;
					/**
					 * 是否已配對過
					 * @example "false"
					 */
					is_ai_mapped?: boolean;
				};
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/app/ai/checkUser`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 取得雲端顧問縣市地區
	 *
	 * @tags Ai
	 * @name V1AppAiDistrictsList
	 * @summary 取得雲端顧問縣市地區
	 * @request GET:/api/v1/app/ai/districts
	 * @secure
	 */
	v1AppAiDistrictsList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 城市區域清單 */
				data?: {
					/**
					 * 城市名稱
					 * @example "台北市"
					 */
					city?: string;
					/** 區域名稱 */
					areas?: string[];
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/app/ai/districts`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description type 必填，可傳 'district', 'coordinate'<br>type=district 時， city, area 必填<br>type=coordinate 時， latitude, longitde 必填
	 *
	 * @tags Ai
	 * @name V1AppAiSalesList
	 * @summary 取得Ai配對雲端顧問網址
	 * @request GET:/api/v1/app/ai/sales
	 * @secure
	 */
	v1AppAiSalesList = (query: V1AppAiSalesListRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/**
				 * 雲端顧問網址
				 * @example "https://test.toyota.com.tw/cloud_sale.aspx?query=劉思妘"
				 */
				data?: string;
			},
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						car_no?: string[];
					};
			  }
		>({
			path: `/api/v1/app/ai/sales`,
			method: 'GET',
			query: query,
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 用戶已配對
	 *
	 * @tags Ai
	 * @name V1AppAiUserMappedUpdate
	 * @summary 用戶已配對
	 * @request PUT:/api/v1/app/ai/userMapped
	 * @secure
	 */
	v1AppAiUserMappedUpdate = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/app/ai/userMapped`,
			method: 'PUT',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 登入
	 *
	 * @tags Auth
	 * @name V1AppAuthLoginCreate
	 * @summary 登入
	 * @request POST:/api/v1/app/auth/login
	 */
	v1AppAuthLoginCreate = (data: V1AppAuthLoginCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: AccessTokenResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						Account?: string[];
					};
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						account?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/login`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 更新token
	 *
	 * @tags Auth
	 * @name V1AppAuthRefreshTokenCreate
	 * @summary 更新token
	 * @request POST:/api/v1/app/auth/refreshToken
	 * @secure
	 */
	v1AppAuthRefreshTokenCreate = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * access token
					 * @example "XXXX.."
					 */
					access_token?: string;
					/**
					 * token類型
					 * @example "Bearer"
					 */
					token_type?: string;
					/**
					 * 過期時間
					 * @example "604800"
					 */
					expires_in?: number;
				};
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						'9107'?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
		>({
			path: `/api/v1/app/auth/refreshToken`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 確認是否已註冊
	 *
	 * @tags Auth
	 * @name V1AppAuthCheckRegisterCreate
	 * @summary 確認是否已註冊
	 * @request POST:/api/v1/app/auth/checkRegister
	 */
	v1AppAuthCheckRegisterCreate = (
		data: V1AppAuthCheckRegisterCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: CheckRegisterResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						Account?: string[];
					};
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						account?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/checkRegister`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 註冊
	 *
	 * @tags Auth
	 * @name V1AppAuthRegisterCreate
	 * @summary 註冊
	 * @request POST:/api/v1/app/auth/register
	 */
	v1AppAuthRegisterCreate = (
		data: V1AppAuthRegisterCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: AccessTokenResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						Account?: string[];
					};
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						account?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/register`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 註冊個人資料
	 *
	 * @tags Auth
	 * @name V1AppAuthRegisterProfileCreate
	 * @summary 註冊個人資料
	 * @request POST:/api/v1/app/auth/registerProfile
	 * @secure
	 */
	v1AppAuthRegisterProfileCreate = (
		data: V1AppAuthRegisterProfileCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						Name?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						name?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/registerProfile`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 取得 email
	 *
	 * @tags Auth
	 * @name V1AppAuthEmailList
	 * @summary 取得 email
	 * @request GET:/api/v1/app/auth/email
	 */
	v1AppAuthEmailList = (query: V1AppAuthEmailListRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: EmailResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						Account?: string[];
					};
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						account?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/email`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 重設密碼
	 *
	 * @tags Auth
	 * @name V1AppAuthResetPasswordCreate
	 * @summary 重設密碼
	 * @request POST:/api/v1/app/auth/resetPassword
	 */
	v1AppAuthResetPasswordCreate = (
		data: V1AppAuthResetPasswordCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						Account?: string[];
					};
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						account?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/resetPassword`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 修改密碼
	 *
	 * @tags Auth
	 * @name V1AppAuthUpdatePasswordCreate
	 * @summary 修改密碼
	 * @request POST:/api/v1/app/auth/updatePassword
	 * @secure
	 */
	v1AppAuthUpdatePasswordCreate = (
		data: V1AppAuthUpdatePasswordCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						OldPassword?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						oldPassword?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/updatePassword`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 確認密碼
	 *
	 * @tags Auth
	 * @name V1AppAuthConfirmPasswordCreate
	 * @summary 確認密碼
	 * @request POST:/api/v1/app/auth/confirmPassword
	 * @secure
	 */
	v1AppAuthConfirmPasswordCreate = (
		data: V1AppAuthConfirmPasswordCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						Password?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						password?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/confirmPassword`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 發送簡訊 OTP
	 *
	 * @tags Auth
	 * @name V1AppAuthSendSmsOtpCreate
	 * @summary 發送簡訊 OTP
	 * @request POST:/api/v1/app/auth/sendSmsOtp
	 */
	v1AppAuthSendSmsOtpCreate = (
		data: V1AppAuthSendSmsOtpCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						MobilePhone?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						mobilePhone?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/sendSmsOtp`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 簡訊 OTP 驗證
	 *
	 * @tags Auth
	 * @name V1AppAuthSmsOtpValidationCreate
	 * @summary 簡訊 OTP 驗證
	 * @request POST:/api/v1/app/auth/smsOtpValidation
	 */
	v1AppAuthSmsOtpValidationCreate = (
		data: V1AppAuthSmsOtpValidationCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: OtpValidationResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						MobilePhone?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						mobilePhone?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/smsOtpValidation`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 驗證會員資訊，取得 OTP 編號
	 *
	 * @tags Auth
	 * @name V1AppAuthOtpValidationCreate
	 * @summary 驗證會員資訊，取得 OTP 編號
	 * @request POST:/api/v1/app/auth/otpValidation
	 */
	v1AppAuthOtpValidationCreate = (
		data: V1AppAuthOtpValidationCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: OtpValidationResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						MobilePhone?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						mobilePhone?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/otpValidation`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 檢查會員權益及隱私條款版本
	 *
	 * @tags Auth
	 * @name V1AppAuthBenefitsAndPrivacyVersionList
	 * @summary 檢查會員權益及隱私條款版本
	 * @request GET:/api/v1/app/auth/benefitsAndPrivacyVersion
	 * @secure
	 */
	v1AppAuthBenefitsAndPrivacyVersionList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: BenefitsAndPrivacyResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						'9201'?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
		>({
			path: `/api/v1/app/auth/benefitsAndPrivacyVersion`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 同意新款會員權益及隱私條款
	 *
	 * @tags Auth
	 * @name V1AppAuthBenefitsAndPrivacyVersionCreate
	 * @summary 同意新款會員權益及隱私條款
	 * @request POST:/api/v1/app/auth/benefitsAndPrivacyVersion
	 * @secure
	 */
	v1AppAuthBenefitsAndPrivacyVersionCreate = (
		data: V1AppAuthBenefitsAndPrivacyVersionCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						'9201'?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						memberBenefitsVersion?: string[];
					};
			  }
		>({
			path: `/api/v1/app/auth/benefitsAndPrivacyVersion`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 登出
	 *
	 * @tags Auth
	 * @name V1AppAuthLogoutCreate
	 * @summary 登出
	 * @request POST:/api/v1/app/auth/logout
	 * @secure
	 */
	v1AppAuthLogoutCreate = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						'9107'?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
		>({
			path: `/api/v1/app/auth/logout`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 取得 ond id hash
	 *
	 * @tags Auth
	 * @name V1AppAuthOneIdHashList
	 * @summary 取得 ond id hash
	 * @request GET:/api/v1/app/auth/oneIdHash
	 * @secure
	 */
	v1AppAuthOneIdHashList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * hash OneID
					 * @example "c94becc158f22013f422cfc9a87f375638f0890f38a16ac50896ac3154973aa4"
					 */
					hash_one_id?: string;
				};
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/app/auth/oneIdHash`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 取得修改會員資料 URL
	 *
	 * @tags Auth
	 * @name V1AppAuthModifyRedirectUriList
	 * @summary 取得修改會員資料 URL
	 * @request GET:/api/v1/app/auth/modifyRedirectUri
	 * @secure
	 */
	v1AppAuthModifyRedirectUriList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "https://oauth-test.hotaimember.com.tw"
					 */
					modifyRedirectUri?: string;
				};
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: string[];
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
		>({
			path: `/api/v1/app/auth/modifyRedirectUri`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 取得活動狀態
	 *
	 * @tags BonusOrderActivity
	 * @name V1AppBonusOrderActivityActivityStatusDetail
	 * @summary 取得活動狀態
	 * @request GET:/api/v1/app/bonusOrderActivity/activityStatus/{no}
	 */
	v1AppBonusOrderActivityActivityStatusDetail = (no: string, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/** @example true */
					isActivityOnline?: boolean;
				};
			},
			any
		>({
			path: `/api/v1/app/bonusOrderActivity/activityStatus/${no}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 取得活動名額
	 *
	 * @tags BonusOrderActivity
	 * @name V1AppBonusOrderActivityQuotasList
	 * @summary 取得活動名額
	 * @request GET:/api/v1/app/bonusOrderActivity/quotas
	 */
	v1AppBonusOrderActivityQuotasList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/** @example 1000 */
					data?: number;
				};
			},
			{
				/**
				 * 回應狀態
				 * @example 404
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "activity expired"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/** @example null */
					data?: null;
				};
			}
		>({
			path: `/api/v1/app/bonusOrderActivity/quotas`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 取得車款等級以及訂單參加活動狀態<br><ul><li>is_car_model_eligible(車款等級是否可以參加活動) == true<ul><li>order_activity_status(訂單參加活動狀態) == true -> 顯示「有名額」文字</li><li>order_activity_status(訂單參加活動狀態) == false -> 顯示「已贈送完畢」文字</li></ul></li><li>is_car_model_eligible(車款等級是否可以參加活動) == false<ul><li>不顯示任何文字</li></ul></li></ul>
	 *
	 * @tags BonusOrderActivity
	 * @name V1AppBonusOrderActivityOrderActivityStatusList
	 * @summary 取得車款等級以及訂單參加活動狀態
	 * @request GET:/api/v1/app/bonusOrderActivity/orderActivityStatus
	 */
	v1AppBonusOrderActivityOrderActivityStatusList = (
		query: V1AppBonusOrderActivityOrderActivityStatusListRequestParams,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: OrderActivityStatusResource;
			},
			any
		>({
			path: `/api/v1/app/bonusOrderActivity/orderActivityStatus`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 建立預扣訂單
	 *
	 * @tags BonusOrderActivity
	 * @name V1AppBonusOrderActivityCreatePendingBonusOrderCreate
	 * @summary 建立預扣訂單
	 * @request POST:/api/v1/app/bonusOrderActivity/createPendingBonusOrder
	 */
	v1AppBonusOrderActivityCreatePendingBonusOrderCreate = (
		data: V1AppBonusOrderActivityCreatePendingBonusOrderCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 預扣訂單編號
					 * @example "TEV123456789"
					 */
					pending_order_id?: string;
				};
			},
			| {
					/**
					 * 回應狀態
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid"
					 */
					message?: string;
					/** 回應資料 */
					errors?: {
						/** @example "您所選的車型沒有贈送\n「和泰 Points 1000 點」喔\n是否要繼續預選" */
						user?: null;
					};
			  }
			| {
					/**
					 * 回應狀態
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid"
					 */
					message?: string;
					/** 回應資料 */
					errors?: {
						/** @example "交車禮「和泰 Points 1000 點」\n贈送名額已額滿\n是否要繼續預選" */
						user?: null;
					};
			  }
		>({
			path: `/api/v1/app/bonusOrderActivity/createPendingBonusOrder`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 更新營業所和業代資訊
	 *
	 * @tags Branch
	 * @name V1WebBranchSalesCreate
	 * @summary 更新營業所和業代資訊
	 * @request POST:/api/v1/web/branch/sales
	 * @secure
	 */
	v1WebBranchSalesCreate = (
		data: V1WebBranchSalesCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/web/branch/sales`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 更新展示車資訊
	 *
	 * @tags Branch
	 * @name V1WebBranchCarsCreate
	 * @summary 更新展示車資訊
	 * @request POST:/api/v1/web/branch/cars
	 * @secure
	 */
	v1WebBranchCarsCreate = (data: V1WebBranchCarsCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/web/branch/cars`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 更新充電樁資訊
	 *
	 * @tags Branch
	 * @name V1WebBranchChargingsCreate
	 * @summary 更新充電樁資訊
	 * @request POST:/api/v1/web/branch/chargings
	 * @secure
	 */
	v1WebBranchChargingsCreate = (
		data: V1WebBranchChargingsCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/web/branch/chargings`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 篩選車款清單
	 *
	 * @tags Car
	 * @name V1AppCarsList
	 * @summary 車款清單
	 * @request GET:/api/v1/app/cars
	 */
	v1AppCarsList = (query: V1AppCarsListRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: CarResource[];
			},
			{
				/**
				 * 回應標題
				 * @example "格式錯誤"
				 */
				title?: string;
				/**
				 * 回應訊息
				 * @example "The given data was invalid."
				 */
				message?: string;
				/** 錯誤資料 */
				errors?: {
					/** 錯誤項目 */
					carType?: string[];
				};
			}
		>({
			path: `/api/v1/app/cars`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 車款內頁資料
	 *
	 * @tags Car
	 * @name V1AppCarsDetail
	 * @summary 車款內頁
	 * @request GET:/api/v1/app/cars/{no}
	 */
	v1AppCarsDetail = ({ no, ...query }: V1AppCarsDetailRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: CarInfoResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 404
					 */
					status?: number;
					/**
					 * 回應訊息
					 * @example "not found"
					 */
					message?: string;
					/** 回應資料 */
					data?: {
						/**
						 * 回應資料
						 * @example "null"
						 */
						data?: string;
					}[];
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						longitude?: string[];
					};
			  }
		>({
			path: `/api/v1/app/cars/${no}`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 車款篩選器<br><br>三種類型<br>- checkbox<br>- slideBar<br>- input<br><a target='_blank' href='https://freezing-log-5c5.notion.site/c5edf641686a4895b87ba272cbc0b47e'>請參考</a>
	 *
	 * @tags Car
	 * @name V1AppCarsFiltersList
	 * @summary 車款篩選器
	 * @request GET:/api/v1/app/cars/filters
	 */
	v1AppCarsFiltersList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 篩選器名稱
					 * @example "車型"
					 */
					name?: string;
					/**
					 * 篩選器回傳參數名稱
					 * @example "carType"
					 */
					filterName?: string;
					/**
					 * 篩選器型態
					 * @example "checkbox"
					 */
					type?: string;
					/**
					 * 篩選器資料
					 * @example "[]"
					 */
					data?: {
						/**
						 * 資料id
						 * @example "1"
						 */
						id?: string;
						/**
						 * 資料文字
						 * @example "油電複合車"
						 */
						text?: string;
					}[];
				}[];
			}[],
			any
		>({
			path: `/api/v1/app/cars/filters`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 交車禮
	 *
	 * @tags Car
	 * @name V1AppCarsGiftsList
	 * @summary 交車禮
	 * @request GET:/api/v1/app/cars/gifts
	 */
	v1AppCarsGiftsList = (query: V1AppCarsGiftsListRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: CarGiftResource[];
			},
			{
				/**
				 * 回應標題
				 * @example "格式錯誤"
				 */
				title?: string;
				/**
				 * 回應訊息
				 * @example "The given data was invalid."
				 */
				message?: string;
				/** 錯誤資料 */
				errors?: {
					/** 錯誤項目 */
					car_no?: string[];
				};
			}
		>({
			path: `/api/v1/app/cars/gifts`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 更新即刻預約試乘車名代碼
	 *
	 * @tags CarPower
	 * @name V1WebCarPowersCreate
	 * @summary 更新即刻預約試乘車名代碼
	 * @request POST:/api/v1/web/car-powers
	 * @secure
	 */
	v1WebCarPowersCreate = (data: V1WebCarPowersCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/web/car-powers`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 註冊裝置
	 *
	 * @tags Device
	 * @name V1AppDevicesRegisterCreate
	 * @summary 註冊裝置
	 * @request POST:/api/v1/app/devices/register
	 */
	v1AppDevicesRegisterCreate = (
		data: V1AppDevicesRegisterCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應標題
				 * @example "格式錯誤"
				 */
				title?: string;
				/**
				 * 回應訊息
				 * @example "The given data was invalid."
				 */
				message?: string;
				/** 錯誤資料 */
				errors?: {
					/** 錯誤項目 */
					device_token?: string[];
				};
			}
		>({
			path: `/api/v1/app/devices/register`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 依據 device_token 和 os_type，記錄對應的 register_id
	 *
	 * @tags Device
	 * @name V1AppDevicesRegisterIdUpdate
	 * @summary 記錄註冊者ID
	 * @request PUT:/api/v1/app/devices/registerId
	 */
	v1AppDevicesRegisterIdUpdate = (
		data: V1AppDevicesRegisterIdUpdateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應標題
				 * @example "格式錯誤"
				 */
				title?: string;
				/**
				 * 回應訊息
				 * @example "The given data was invalid."
				 */
				message?: string;
				/** 錯誤資料 */
				errors?: {
					/** 錯誤項目 */
					register_id?: string[];
					/** 錯誤項目 */
					device_token?: string[];
					/** 錯誤項目 */
					os_type?: string[];
				};
			}
		>({
			path: `/api/v1/app/devices/registerId`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 依據 device_token 和 os_type，記錄對應的 pseudo_id
	 *
	 * @tags Device
	 * @name V1AppDevicesPseudoIdUpdate
	 * @summary 存取 user pseudo ID
	 * @request PUT:/api/v1/app/devices/pseudoId
	 */
	v1AppDevicesPseudoIdUpdate = (
		data: V1AppDevicesPseudoIdUpdateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應標題
				 * @example "格式錯誤"
				 */
				title?: string;
				/**
				 * 回應訊息
				 * @example "The given data was invalid."
				 */
				message?: string;
				/** 錯誤資料 */
				errors?: {
					/** 錯誤項目 */
					pseudo_id?: string[];
					/** 錯誤項目 */
					device_token?: string[];
					/** 錯誤項目 */
					os_type?: string[];
				};
			}
		>({
			path: `/api/v1/app/devices/pseudoId`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 購車優惠
	 *
	 * @tags Discount
	 * @name V1AppDiscountsList
	 * @summary 購車優惠
	 * @request GET:/api/v1/app/discounts
	 */
	v1AppDiscountsList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: DiscountResource[];
			},
			any
		>({
			path: `/api/v1/app/discounts`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags EcPay
	 * @name V1WebEcpayPaymentCreate
	 * @summary 取得付款HTML
	 * @request POST:/api/v1/web/ecpay/payment
	 */
	v1WebEcpayPaymentCreate = (
		data: V1WebEcpayPaymentCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example "200"
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "<!DOCTYPE html>綠界付款頁面</html>"
					 */
					data?: string;
				};
			},
			| {
					/**
					 * 回應狀態
					 * @example "403"
					 */
					status?: number;
					/**
					 * 回應訊息
					 * @example "此筆報名不可付款"
					 */
					message?: string;
					/** 回應資料 */
					data?: {
						/**
						 * 回應資料
						 * @example null
						 */
						data?: string;
					};
			  }
			| {
					/**
					 * 回應狀態
					 * @example "格式錯誤"
					 */
					title?: number;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 回應資料 */
					errors?: {
						/** 回應資料 */
						love_code?: string[];
					};
			  }
		>({
			path: `/api/v1/web/ecpay/payment`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags EcPay
	 * @name V1WebEcpayPaymentResultDetail
	 * @summary 取得付款結果
	 * @request GET:/api/v1/web/ecpay/paymentResult/{event_registration_id}
	 */
	v1WebEcpayPaymentResultDetail = (eventRegistrationId: number, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example "200"
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: PaymentResultResource;
			},
			{
				/**
				 * 回應狀態
				 * @example "404"
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "查無資料"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example null
					 */
					data?: string;
				};
			}
		>({
			path: `/api/v1/web/ecpay/paymentResult/${eventRegistrationId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description GR活動清單</br> *       排序方式：現正報名中（權重大到小） --> Coming Soon（權重大到小） --> 報名已截止（權重大到小）</br> *       活動開放報名狀態(registration_status)： 現正報名中: （空字串）, 報名尚未開始: 'Coming Soon', 報名已截止: '報名已截止' *
	 *
	 * @tags Event
	 * @name V1WebEventsList
	 * @summary GR活動清單
	 * @request GET:/api/v1/web/events
	 */
	v1WebEventsList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: EventResource[];
			},
			any
		>({
			path: `/api/v1/web/events`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description GR活動內頁<br>場次無限額則限額欄位(quota)為'N/A'
	 *
	 * @tags Event
	 * @name V1WebEventsDetail
	 * @summary GR活動內頁
	 * @request GET:/api/v1/web/events/{id}
	 */
	v1WebEventsDetail = (id: number, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: EventShowResource[];
			},
			{
				/**
				 * 回應狀態
				 * @example 404
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "not found"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			}
		>({
			path: `/api/v1/web/events/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description GR報名紀錄列表頁
	 *
	 * @tags EventRegistration
	 * @name V1WebEventRegistrationsList
	 * @summary GR報名紀錄列表頁
	 * @request GET:/api/v1/web/event-registrations
	 * @secure
	 */
	v1WebEventRegistrationsList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: EventRegistrationIndexResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/web/event-registrations`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description GR報名紀錄內頁
	 *
	 * @tags EventRegistration
	 * @name V1WebEventRegistrationsDetail
	 * @summary GR報名紀錄內頁
	 * @request GET:/api/v1/web/event-registrations/{id}
	 * @secure
	 */
	v1WebEventRegistrationsDetail = (id: number, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: EventRegistrationShowResource;
			},
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應訊息
					 * @example "This action is unauthorized."
					 */
					message?: string;
			  }
			| {
					/**
					 * 回應訊息
					 * @example "No query results for model [App\Models\EventRegistration] {id}"
					 */
					message?: string;
			  }
		>({
			path: `/api/v1/web/event-registrations/${id}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 交車禮狀態
	 *
	 * @tags Gift
	 * @name V1AppGiftsStatusList
	 * @summary 交車禮狀態
	 * @request GET:/api/v1/app/gifts/status
	 */
	v1AppGiftsStatusList = (query: V1AppGiftsStatusListRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/** @example null */
					data?: null;
				};
			},
			{
				/**
				 * 回應標題
				 * @example "格式錯誤"
				 */
				title?: string;
				/**
				 * 回應訊息
				 * @example "The given data was invalid."
				 */
				message?: string;
				/** 錯誤資料 */
				errors?: {
					/** 錯誤項目 */
					gifts?: string[];
				};
			}
		>({
			path: `/api/v1/app/gifts/status`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description GR彈窗API
	 *
	 * @tags GrModal
	 * @name V1WebGrModalList
	 * @summary GR彈窗API
	 * @request GET:/api/v1/web/gr-modal
	 * @secure
	 */
	v1WebGrModalList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: GrModalResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/web/gr-modal`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 首頁api
	 *
	 * @tags Home
	 * @name V1AppHomeList
	 * @summary 首頁api
	 * @request GET:/api/v1/app/home
	 */
	v1AppHomeList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: HomeResource;
			},
			any
		>({
			path: `/api/v1/app/home`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 集團服務
	 *
	 * @tags HotaiMember
	 * @name V1AppGroupAppsList
	 * @summary 集團服務
	 * @request GET:/api/v1/app/groupApps
	 */
	v1AppGroupAppsList = (query: V1AppGroupAppsListRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: GroupAppsResource[];
			},
			any
		>({
			path: `/api/v1/app/groupApps`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 取得會員權益及隱私條款 (文字中有\n 或\\n，表示需斷行處理)
	 *
	 * @tags HotaiMember
	 * @name V1AppPrivacyList
	 * @summary 取得會員權益及隱私條款
	 * @request GET:/api/v1/app/privacy
	 */
	v1AppPrivacyList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: PrivacyResource;
			},
			any
		>({
			path: `/api/v1/app/privacy`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 觸發LBS推播
	 *
	 * @tags LbsMessage
	 * @name V1AppLbsMessagesNotificationCreate
	 * @summary 觸發LBS推播
	 * @request POST:/api/v1/app/lbsMessages/notification
	 */
	v1AppLbsMessagesNotificationCreate = (
		data: V1AppLbsMessagesNotificationCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 404
					 */
					status?: number;
					/**
					 * 回應訊息
					 * @example "Device not found"
					 */
					message?: string;
					/** 回應資料 */
					data?: {
						/**
						 * 回應資料
						 * @example "null"
						 */
						data?: string;
					}[];
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data is invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						registerId?: string[];
						/** 錯誤項目 */
						locations?: string[];
						/** 錯誤項目 */
						dealer?: string[];
						/** 錯誤項目 */
						branch?: string[];
					};
			  }
		>({
			path: `/api/v1/app/lbsMessages/notification`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 取得LBS訊息觸發範圍
	 *
	 * @tags LbsMessageTriggerRange
	 * @name V1AppLbsMessageTriggerRangeList
	 * @summary 取得LBS訊息觸發範圍
	 * @request GET:/api/v1/app/lbsMessageTriggerRange
	 */
	v1AppLbsMessageTriggerRangeList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * LBS訊息觸發範圍
					 * @example 150
					 */
					range?: number;
				};
			},
			any
		>({
			path: `/api/v1/app/lbsMessageTriggerRange`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 營業所清單<br><a target='_blank' href='https://freezing-log-5c5.notion.site/api-f23acbb0b8f04e8f9136df79c8745c5f'>請參考</a>
	 *
	 * @tags Location
	 * @name V1AppLocationsList
	 * @summary 營業所清單
	 * @request GET:/api/v1/app/locations
	 */
	v1AppLocationsList = (query: V1AppLocationsListRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: LocationResource[];
			},
			any
		>({
			path: `/api/v1/app/locations`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 據點城市區域清單
	 *
	 * @tags Location
	 * @name V1AppCityRegionsList
	 * @summary 據點城市區域清單
	 * @request GET:/api/v1/app/city_regions
	 */
	v1AppCityRegionsList = (query: V1AppCityRegionsListRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example ""
				 */
				message?: string;
				/** 城市區域清單 */
				data?: {
					/**
					 * 城市名稱
					 * @example "台北市"
					 */
					city?: string;
					/** 區域名稱 */
					areas?: string[];
				}[];
			},
			any
		>({
			path: `/api/v1/app/city_regions`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 寄送驗證碼
	 *
	 * @tags Mobile
	 * @name V1AppMobileCreate
	 * @summary 寄送驗證碼
	 * @request POST:/api/v1/app/mobile
	 */
	v1AppMobileCreate = (data: V1AppMobileCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			any
		>({
			path: `/api/v1/app/mobile`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 驗證碼驗證
	 *
	 * @tags Mobile
	 * @name V1AppMobileVerifyCreate
	 * @summary 驗證碼驗證
	 * @request POST:/api/v1/app/mobile/verify
	 */
	v1AppMobileVerifyCreate = (
		data: V1AppMobileVerifyCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應狀態
				 * @example 400
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "驗證錯誤"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			}
		>({
			path: `/api/v1/app/mobile/verify`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 通知清單查詢(依裝置token)
	 *
	 * @tags Notification
	 * @name V1AppNotificationsList
	 * @summary 通知清單(依裝置token)
	 * @request GET:/api/v1/app/notifications
	 */
	v1AppNotificationsList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: NotificationResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "The device token was invalid."
				 */
				message?: string;
			}
		>({
			path: `/api/v1/app/notifications`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 全部標示為已讀
	 *
	 * @tags Notification
	 * @name V1AppNotificationsUpdate
	 * @summary 全部標示為已讀
	 * @request PUT:/api/v1/app/notifications
	 */
	v1AppNotificationsUpdate = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "The device token was invalid."
				 */
				message?: string;
			}
		>({
			path: `/api/v1/app/notifications`,
			method: 'PUT',
			format: 'json',
			...params,
		});
	/**
	 * @description 標示為已讀
	 *
	 * @tags Notification
	 * @name V1AppNotificationsUpdate2
	 * @summary 標示為已讀
	 * @request PUT:/api/v1/app/notifications/{id}
	 * @originalName v1AppNotificationsUpdate
	 * @duplicate
	 */
	v1AppNotificationsUpdate2 = (id: string, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應訊息
					 * @example "The device token was invalid."
					 */
					message?: string;
			  }
			| {
					/**
					 * 回應狀態
					 * @example 404
					 */
					status?: number;
					/**
					 * 回應訊息
					 * @example "not found"
					 */
					message?: string;
					/** 回應資料 */
					data?: {
						/**
						 * 回應資料
						 * @example "null"
						 */
						data?: string;
					}[];
			  }
		>({
			path: `/api/v1/app/notifications/${id}`,
			method: 'PUT',
			format: 'json',
			...params,
		});
	/**
	 * @description 刪除通知
	 *
	 * @tags Notification
	 * @name V1AppNotificationsDelete
	 * @summary 刪除通知
	 * @request DELETE:/api/v1/app/notifications/{id}
	 */
	v1AppNotificationsDelete = (id: string, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應訊息
					 * @example "The device token was invalid."
					 */
					message?: string;
			  }
			| {
					/**
					 * 回應狀態
					 * @example 404
					 */
					status?: number;
					/**
					 * 回應訊息
					 * @example "not found"
					 */
					message?: string;
					/** 回應資料 */
					data?: {
						/**
						 * 回應資料
						 * @example "null"
						 */
						data?: string;
					}[];
			  }
		>({
			path: `/api/v1/app/notifications/${id}`,
			method: 'DELETE',
			format: 'json',
			...params,
		});
	/**
	 * @description 推播訊息數據追蹤
	 *
	 * @tags Notification
	 * @name V1AppNotificationsAnalyticCreate
	 * @summary 推播訊息數據追蹤
	 * @request POST:/api/v1/app/notifications/{id}/analytic
	 */
	v1AppNotificationsAnalyticCreate = (
		id: string,
		data: V1AppNotificationsAnalyticCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應訊息
					 * @example "The device token was invalid."
					 */
					message?: string;
			  }
			| {
					/**
					 * 回應狀態
					 * @example 404
					 */
					status?: number;
					/**
					 * 回應訊息
					 * @example "not found"
					 */
					message?: string;
					/** 回應資料 */
					data?: {
						/**
						 * 回應資料
						 * @example "null"
						 */
						data?: string;
					}[];
			  }
		>({
			path: `/api/v1/app/notifications/${id}/analytic`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 預約單查詢(依裝置token)
	 *
	 * @tags Order
	 * @name V1AppOrdersList
	 * @summary 預約單查詢(依裝置token)
	 * @request GET:/api/v1/app/orders
	 */
	v1AppOrdersList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: OrderListResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "The device token was invalid."
				 */
				message?: string;
			}
		>({
			path: `/api/v1/app/orders`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 立即購車(預約付款)<br><a target='_blank' href='https://freezing-log-5c5.notion.site/api-408451a58aa04753becc39456189df55'>請參考</a>
	 *
	 * @tags Order
	 * @name V1AppOrdersCreate
	 * @summary 立即購車(預約付款)
	 * @request POST:/api/v1/app/orders
	 */
	v1AppOrdersCreate = (data: V1AppOrdersCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "預約成功"
				 */
				message?: string;
				data?: OrderStoreResource;
			},
			| {
					/**
					 * 回應訊息
					 * @example "The device token was invalid."
					 */
					message?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						sales_no?: string[];
					};
			  }
		>({
			path: `/api/v1/app/orders`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 付款預選單查詢(d)
	 *
	 * @tags Order
	 * @name V1AppOrdersDetail
	 * @summary 付款預選單查詢(id)
	 * @request GET:/api/v1/app/orders/{id}
	 */
	v1AppOrdersDetail = (id: number, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: OrderShowResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "The device token was invalid."
				 */
				message?: string;
			}
		>({
			path: `/api/v1/app/orders/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 更新付款預選單
	 *
	 * @tags Order
	 * @name V1WebOrdersUpdate
	 * @summary 更新付款預選單
	 * @request PUT:/api/v1/web/orders
	 * @secure
	 */
	v1WebOrdersUpdate = (data: V1WebOrdersUpdateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/web/orders`,
			method: 'PUT',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 回補預選單付款狀態
	 *
	 * @tags Order
	 * @name V1WebOrderPaymentsCreate
	 * @summary 回補預選單付款狀態
	 * @request POST:/api/v1/web/order_payments
	 * @secure
	 */
	v1WebOrderPaymentsCreate = (
		data: V1WebOrderPaymentsCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						Order_Info?: string[];
					};
			  }
		>({
			path: `/api/v1/web/order_payments`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description QR Code 掃描轉導
	 *
	 * @tags QrCode
	 * @name V1QrCodeRdDetail
	 * @summary QR Code 掃描轉導
	 * @request GET:/api/v1/qrCode/rd/{dealerCode}/{branchCode}/{branchType}/{sectionCode}/{salesCode}
	 */
	v1QrCodeRdDetail = (
		dealerCode: string,
		branchCode: string,
		branchType: string,
		sectionCode: string,
		salesCode: string,
		params: RequestParams = {},
	) =>
		this.http.request<any, void>({
			path: `/api/v1/qrCode/rd/${dealerCode}/${branchCode}/${branchType}/${sectionCode}/${salesCode}`,
			method: 'GET',
			...params,
		});
	/**
	 * @description QR Code 下載紀錄
	 *
	 * @tags QrCode
	 * @name V1QrCodeDlCreate
	 * @summary QR Code 下載紀錄
	 * @request POST:/api/v1/qrCode/dl/{dealerCode}/{branchCode}/{branchType}/{sectionCode}/{salesCode}
	 */
	v1QrCodeDlCreate = (
		dealerCode: string,
		branchCode: string,
		branchType: string,
		sectionCode: string,
		salesCode: string,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應訊息
					 * @example "The device token was invalid."
					 */
					message?: string;
			  }
			| {
					/**
					 * 回應訊息
					 * @example "The device token already exists."
					 */
					message?: string;
			  }
		>({
			path: `/api/v1/qrCode/dl/${dealerCode}/${branchCode}/${branchType}/${sectionCode}/${salesCode}`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description 預約單查詢(依裝置token)
	 *
	 * @tags Reservation
	 * @name V1AppReservationsList
	 * @summary 預約單查詢(依裝置token)
	 * @request GET:/api/v1/app/reservations
	 */
	v1AppReservationsList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: ReservationListResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "The device token was invalid."
				 */
				message?: string;
			}
		>({
			path: `/api/v1/app/reservations`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 預約試乘<br><a target='_blank' href='https://freezing-log-5c5.notion.site/api-db58eef7169a44d9a1e082e6d6d3a980'>請參考</a>
	 *
	 * @tags Reservation
	 * @name V1AppReservationsCreate
	 * @summary 預約試乘
	 * @request POST:/api/v1/app/reservations
	 */
	v1AppReservationsCreate = (
		data: V1AppReservationsCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "預約成功"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "The device token was invalid."
				 */
				message?: string;
			}
		>({
			path: `/api/v1/app/reservations`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 預約單查詢(依預約單id)
	 *
	 * @tags Reservation
	 * @name V1AppReservationsDetail
	 * @summary 預約單查詢(依預約單id)
	 * @request GET:/api/v1/app/reservations/{id}
	 */
	v1AppReservationsDetail = (id: number, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: ReservationShowResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "The device token was invalid."
				 */
				message?: string;
			}
		>({
			path: `/api/v1/app/reservations/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 預約服務項目清單資料
	 *
	 * @tags Reservation
	 * @name V1AppReservationItemsList
	 * @summary 預約服務項目清單
	 * @request GET:/api/v1/app/reservation_items
	 */
	v1AppReservationItemsList = (
		query: V1AppReservationItemsListRequestParams,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: ReservationItemResource[];
			},
			any
		>({
			path: `/api/v1/app/reservation_items`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 取得即刻預約試乘可預約時間與車輛狀態
	 *
	 * @tags InstantReservation
	 * @name V1AppInstantReservationsAvailableRsvDateTimeList
	 * @summary 取得即刻預約試乘可預約時間與車輛狀態
	 * @request GET:/api/v1/app/instantReservations/availableRsvDateTime
	 */
	v1AppInstantReservationsAvailableRsvDateTimeList = (
		query: V1AppInstantReservationsAvailableRsvDateTimeListRequestParams,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: ReservationInstantAvailableRsvDateTimeResource[];
			},
			any
		>({
			path: `/api/v1/app/instantReservations/availableRsvDateTime`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 即刻預約試乘
	 *
	 * @tags InstantReservation
	 * @name V1AppInstantReservationsCreate
	 * @summary 即刻預約試乘
	 * @request POST:/api/v1/app/instantReservations
	 * @secure
	 */
	v1AppInstantReservationsCreate = (
		data: V1AppInstantReservationsCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "即刻預約試乘成功"
				 */
				message?: string;
				data?: ReservationInstantReserveResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應訊息
					 * @example "即刻預約試乘失敗"
					 */
					message?: string;
					/** 回應資料 */
					data?: {
						/**
						 * 回應資料
						 * @example "null"
						 */
						data?: string;
					}[];
			  }
			| {
					/**
					 * 回應訊息
					 * @example "The device token was invalid."
					 */
					message?: string;
			  }
		>({
			path: `/api/v1/app/instantReservations`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 業代清單
	 *
	 * @tags Sales
	 * @name V1AppSalesList
	 * @summary 業代清單
	 * @request GET:/api/v1/app/sales
	 */
	v1AppSalesList = (query: V1AppSalesListRequestParams, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: SalesResource[];
			},
			any
		>({
			path: `/api/v1/app/sales`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description 評分
	 *
	 * @tags Score
	 * @name V1AppScoreCreate
	 * @summary 評分
	 * @request POST:/api/v1/app/score
	 * @secure
	 */
	v1AppScoreCreate = (data: ScoreStoreRequest, params: RequestParams = {}) =>
		this.http.request<
			{
				/** @example "200" */
				status?: number;
				/** @example "successful" */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 分數錯誤 */
						score?: {
							/**
							 * 分數必須是數字
							 * @example "The score must be an integer."
							 */
							'0'?: string;
							/**
							 * 分數必須介於1~5之間
							 * @example "The score must be between 1 and 5."
							 */
							'1'?: string;
						}[];
					};
			  }
		>({
			path: `/api/v1/app/score`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Referral API
	 *
	 * @tags SurveyCake
	 * @name V1AppSurveycakeReferralCreate
	 * @summary Referral API
	 * @request POST:/api/v1/app/surveycake/referral
	 * @secure
	 */
	v1AppSurveycakeReferralCreate = (
		data: V1AppSurveycakeReferralCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: SurveycakeReferralResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應訊息
					 * @example "Survercake ReferralApi錯誤"
					 */
					message?: string;
					/** 回應資料 */
					surveycake_url?: string[];
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						surveycake_url?: string[];
					};
			  }
		>({
			path: `/api/v1/app/surveycake/referral`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 會員資料
	 *
	 * @tags User
	 * @name V1AppUserList
	 * @summary 會員資料
	 * @request GET:/api/v1/app/user
	 * @secure
	 */
	v1AppUserList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: UserShowResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/app/user`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 更新會員資料
	 *
	 * @tags User
	 * @name V1AppUserUpdate
	 * @summary 更新會員資料
	 * @request PUT:/api/v1/app/user
	 * @secure
	 */
	v1AppUserUpdate = (data: V1AppUserUpdateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						Sex?: string[];
						/** 錯誤項目 */
						Email?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						name?: string[];
					};
			  }
		>({
			path: `/api/v1/app/user`,
			method: 'PUT',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 更新會員帳號
	 *
	 * @tags User
	 * @name V1AppUserAccountUpdate
	 * @summary 更新會員帳號
	 * @request PUT:/api/v1/app/user/account
	 * @secure
	 */
	v1AppUserAccountUpdate = (
		data: V1AppUserAccountUpdateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						'9301'?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						account?: string[];
					};
			  }
		>({
			path: `/api/v1/app/user/account`,
			method: 'PUT',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 確認User是否為GR會員
	 *
	 * @tags User(Web)
	 * @name V1WebUserGrMembershipList
	 * @summary 確認User是否為GR會員
	 * @request GET:/api/v1/web/user/gr-membership
	 * @secure
	 */
	v1WebUserGrMembershipList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 是否為GR會員
					 * @example true
					 */
					is_gr_member?: boolean;
				};
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v1/web/user/gr-membership`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 加入GR會員
	 *
	 * @tags User(Web)
	 * @name V1WebUserGrMembershipCreate
	 * @summary 加入GR會員
	 * @request POST:/api/v1/web/user/gr-membership
	 * @secure
	 */
	v1WebUserGrMembershipCreate = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應訊息
					 * @example "error"
					 */
					message?: string;
					/** 回應資料 */
					data?: {
						/**
						 * 回應資料
						 * @example "null"
						 */
						data?: string;
					}[];
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應狀態
					 * @example 422
					 */
					status?: number;
					/**
					 * 錯誤訊息
					 * @example "This user already has GR membership"
					 */
					message?: string;
			  }
		>({
			path: `/api/v1/web/user/gr-membership`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description Web登入
	 *
	 * @tags Auth(V2)
	 * @name V2WebAuthLoginCreate
	 * @summary 登入
	 * @request POST:/api/v2/web/auth/login
	 */
	v2WebAuthLoginCreate = (data: V2WebAuthLoginCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: AccessTokenResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "錯誤"
					 */
					title?: string;
					/** 錯誤訊息 */
					errors?: string[];
				}
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						authorizationCode?: string[];
						/** 錯誤項目 */
						codeVerifier?: string[];
						/** 錯誤項目 */
						memberSeq?: string[];
					};
				}
		>({
			path: `/api/v2/web/auth/login`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 登入
	 *
	 * @tags Auth(V2)
	 * @name V2AppAuthLoginCreate
	 * @summary 登入
	 * @request POST:/api/v2/app/auth/login
	 */
	v2AppAuthLoginCreate = (data: V2AppAuthLoginCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: AccessTokenResource;
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "錯誤"
					 */
					title?: string;
					/** 錯誤訊息 */
					errors?: string[];
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						authorizationCode?: string[];
						/** 錯誤項目 */
						codeVerifier?: string[];
						/** 錯誤項目 */
						memberSeq?: string[];
					};
			  }
		>({
			path: `/api/v2/app/auth/login`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 更新token
	 *
	 * @tags Auth(V2)
	 * @name V2AppAuthRefreshTokenCreate
	 * @summary 更新token
	 * @request POST:/api/v2/app/auth/refreshToken
	 * @secure
	 */
	v2AppAuthRefreshTokenCreate = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * access token
					 * @example "XXXX.."
					 */
					access_token?: string;
					/**
					 * token類型
					 * @example "Bearer"
					 */
					token_type?: string;
					/**
					 * 過期時間
					 * @example "604800"
					 */
					expires_in?: number;
				};
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "該操作發生錯誤"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						'9107'?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
		>({
			path: `/api/v2/app/auth/refreshToken`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 登出
	 *
	 * @tags Auth(V2)
	 * @name V2AppAuthLogoutCreate
	 * @summary 登出
	 * @request POST:/api/v2/app/auth/logout
	 * @secure
	 */
	v2AppAuthLogoutCreate = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應狀態
					 * @example 400
					 */
					status?: number;
					/**
					 * 回應標題
					 * @example "發生錯誤，請重新嘗試登入"
					 */
					title?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						'8004'?: string[];
					};
			  }
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
		>({
			path: `/api/v2/app/auth/logout`,
			method: 'POST',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 註冊裝置
	 *
	 * @tags Device(V2)
	 * @name V2AppDevicesRegisterCreate
	 * @summary 註冊裝置
	 * @request POST:/api/v2/app/devices/register
	 * @secure
	 */
	v2AppDevicesRegisterCreate = (
		data: V2AppDevicesRegisterCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						device_token?: string[];
					};
			  }
		>({
			path: `/api/v2/app/devices/register`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 首頁api
	 *
	 * @tags Home(V2)
	 * @name V2AppHomeList
	 * @summary 首頁api
	 * @request GET:/api/v2/app/home
	 */
	v2AppHomeList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				data?: HomeResourceV2;
			},
			any
		>({
			path: `/api/v2/app/home`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description 預約單查詢(依裝置token)
	 *
	 * @tags Order(V2)
	 * @name V2AppOrdersList
	 * @summary 預約單查詢(依裝置token)
	 * @request GET:/api/v2/app/orders
	 * @secure
	 */
	v2AppOrdersList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: OrderListResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v2/app/orders`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 立即購車(預約付款)<br><a target='_blank' href='https://freezing-log-5c5.notion.site/api-408451a58aa04753becc39456189df55'>請參考</a>
	 *
	 * @tags Order(V2)
	 * @name V2AppOrdersCreate
	 * @summary 立即購車(預約付款)
	 * @request POST:/api/v2/app/orders
	 * @secure
	 */
	v2AppOrdersCreate = (data: V2AppOrdersCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "預約成功"
				 */
				message?: string;
				data?: OrderStoreAuthResource;
			},
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "您已完成過預選登錄"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "This action is unauthorized."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						user?: string[];
					};
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						sales_no?: string[];
					};
			  }
		>({
			path: `/api/v2/app/orders`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 付款預選單查詢(d)
	 *
	 * @tags Order(V2)
	 * @name V2AppOrdersDetail
	 * @summary 付款預選單查詢(id)
	 * @request GET:/api/v2/app/orders/{id}
	 * @secure
	 */
	v2AppOrdersDetail = (id: number, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: OrderShowResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v2/app/orders/${id}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 預約單查詢(依裝置token)
	 *
	 * @tags Reservation(V2)
	 * @name V2AppReservationsList
	 * @summary 預約單查詢(依裝置token)
	 * @request GET:/api/v2/app/reservations
	 * @secure
	 */
	v2AppReservationsList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: ReservationListResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v2/app/reservations`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 預約試乘<br><a target='_blank' href='https://freezing-log-5c5.notion.site/api-db58eef7169a44d9a1e082e6d6d3a980'>請參考</a>
	 *
	 * @tags Reservation(V2)
	 * @name V2AppReservationsCreate
	 * @summary 預約試乘
	 * @request POST:/api/v2/app/reservations
	 * @secure
	 */
	v2AppReservationsCreate = (
		data: V2AppReservationsCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "預約成功"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v2/app/reservations`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 預約單查詢(依預約單id)
	 *
	 * @tags Reservation(V2)
	 * @name V2AppReservationsDetail
	 * @summary 預約單查詢(依預約單id)
	 * @request GET:/api/v2/app/reservations/{id}
	 * @secure
	 */
	v2AppReservationsDetail = (id: number, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: ReservationShowResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v2/app/reservations/${id}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 會員資料
	 *
	 * @tags User(V2)
	 * @name V2AppUserList
	 * @summary 會員資料
	 * @request GET:/api/v2/app/user
	 * @secure
	 */
	v2AppUserList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: UserShowResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v2/app/user`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 會員資料Web
	 *
	 * @tags User(V2)Web
	 * @name V2WebUserList
	 * @summary 會員資料Web
	 * @request GET:/api/v2/web/user
	 * @secure
	 */
	v2WebUserList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: UserShowResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v2/web/user`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 註冊裝置
	 *
	 * @tags Device(V3)
	 * @name V3AppDevicesRegisterCreate
	 * @summary 註冊裝置
	 * @request POST:/api/v3/app/devices/register
	 * @secure
	 */
	v3AppDevicesRegisterCreate = (
		data: V3AppDevicesRegisterCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						device_token?: string[];
					};
			  }
		>({
			path: `/api/v3/app/devices/register`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 預約單查詢(依裝置token)
	 *
	 * @tags Order(V3)
	 * @name V3AppOrdersList
	 * @summary 預約單查詢(依裝置token)
	 * @request GET:/api/v3/app/orders
	 * @secure
	 */
	v3AppOrdersList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: OrderListResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v3/app/orders`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 立即購車(預約付款)<br><a target='_blank' href='https://freezing-log-5c5.notion.site/api-408451a58aa04753becc39456189df55'>請參考</a>
	 *
	 * @tags Order(V3)
	 * @name V3AppOrdersCreate
	 * @summary 立即購車(預約付款)
	 * @request POST:/api/v3/app/orders
	 * @secure
	 */
	v3AppOrdersCreate = (data: V3AppOrdersCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "預約成功"
				 */
				message?: string;
				data?: OrderStoreAuthResource;
			},
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "您已完成過預選登錄"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "This action is unauthorized."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						user?: string[];
					};
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						sales_no?: string[];
					};
			  }
		>({
			path: `/api/v3/app/orders`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 付款預選單查詢(d)
	 *
	 * @tags Order(V3)
	 * @name V3AppOrdersDetail
	 * @summary 付款預選單查詢(id)
	 * @request GET:/api/v3/app/orders/{id}
	 * @secure
	 */
	v3AppOrdersDetail = (id: number, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: OrderShowResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v3/app/orders/${id}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 預約單查詢(依裝置token)
	 *
	 * @tags Reservation(V3)
	 * @name V3AppReservationsList
	 * @summary 預約單查詢(依裝置token)
	 * @request GET:/api/v3/app/reservations
	 * @secure
	 */
	v3AppReservationsList = (params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: ReservationListResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v3/app/reservations`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 預約試乘<br><a target='_blank' href='https://freezing-log-5c5.notion.site/api-db58eef7169a44d9a1e082e6d6d3a980'>請參考</a>
	 *
	 * @tags Reservation(V3)
	 * @name V3AppReservationsCreate
	 * @summary 預約試乘
	 * @request POST:/api/v3/app/reservations
	 * @secure
	 */
	v3AppReservationsCreate = (
		data: V3AppReservationsCreateRequestPayload,
		params: RequestParams = {},
	) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "預約成功"
				 */
				message?: string;
				/** 回應資料 */
				data?: {
					/**
					 * 回應資料
					 * @example "null"
					 */
					data?: string;
				}[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v3/app/reservations`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description 預約單查詢(依預約單id)
	 *
	 * @tags Reservation(V3)
	 * @name V3AppReservationsDetail
	 * @summary 預約單查詢(依預約單id)
	 * @request GET:/api/v3/app/reservations/{id}
	 * @secure
	 */
	v3AppReservationsDetail = (id: number, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "successful"
				 */
				message?: string;
				/** 回應資料 */
				data?: ReservationShowResource[];
			},
			{
				/**
				 * 回應訊息
				 * @example "Unauthenticated"
				 */
				error?: string;
			}
		>({
			path: `/api/v3/app/reservations/${id}`,
			method: 'GET',
			secure: true,
			format: 'json',
			...params,
		});
	/**
	 * @description 立即購車(預約付款)<br><a target='_blank' href='https://freezing-log-5c5.notion.site/api-408451a58aa04753becc39456189df55'>請參考</a>
	 *
	 * @tags Order(V4)
	 * @name V4AppOrdersCreate
	 * @summary 立即購車(預約付款)
	 * @request POST:/api/v4/app/orders
	 * @secure
	 */
	v4AppOrdersCreate = (data: V4AppOrdersCreateRequestPayload, params: RequestParams = {}) =>
		this.http.request<
			{
				/**
				 * 回應狀態
				 * @example 200
				 */
				status?: number;
				/**
				 * 回應訊息
				 * @example "預約成功"
				 */
				message?: string;
				data?: OrderStoreAuthResource;
			},
			| {
					/**
					 * 回應訊息
					 * @example "Unauthenticated"
					 */
					error?: string;
			  }
			| {
					/**
					 * 回應標題
					 * @example "您已完成過預選登錄"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "This action is unauthorized."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						user?: string[];
					};
			  }
			| {
					/**
					 * 回應標題
					 * @example "格式錯誤"
					 */
					title?: string;
					/**
					 * 回應訊息
					 * @example "The given data was invalid."
					 */
					message?: string;
					/** 錯誤資料 */
					errors?: {
						/** 錯誤項目 */
						sales_no?: string[];
					};
			  }
		>({
			path: `/api/v4/app/orders`,
			method: 'POST',
			body: data,
			secure: true,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
}
